var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.75 12.36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.28.28a1 1 0 0 1 1.4 0l9.69 9.7 9.69-9.7a1 1 0 0 1 1.39 1.4L12.06 12.06a1 1 0 0 1-1.39 0L.28 1.68a1 1 0 0 1 0-1.39Z"
  })));
};
export default SvgChevronDown;